// For error codes (unauthenticated)
export const UNAUTHENTICATED = "UNAUTHENTICATED";
